import React from "react";
import {
  Button,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";
import { YMaps, Map, Placemark } from 'react-yandex-maps'
import styled from 'styled-components'
import axios  from 'axios'
import { useTranslation } from 'react-i18next';

const MapStyled = styled(Map)`
    height: 470px;
    width: 100%;
    margin-top: 40px;
`

const ContactUs = () =>{
  const {t} = useTranslation();
  return (
    <>
        <div className="section landing-section">
          <Container>
            <Row>
              <Col md="6">
              <YMaps>
                <div>
                  <MapStyled defaultState={{ center: [56.941231, 24.289271], zoom: 14 }} >
                    <Placemark defaultGeometry={[56.940645, 24.289897]} />
                  </MapStyled>
                </div>
              </YMaps>
              </Col>
              <Col className="ml-auto mr-auto" md="6">
                <h2 className="text-center">{t('ContactUs')}</h2>
                <Form className="contact-form">
                  <Row>
                    <Col md="12">
                      <h5><b>{t('Adress')}:</b> Latvian: Instituta iela 36 - 17, Ulbroka, Stopinu novads, Latvia, LV-2130</h5>
                    </Col>
                    <Col md="12">
                    </Col>
                    <Col md="12">
                      <h5><b>{t('Email')}:</b> info@austrum-logistics.lv</h5>
                    </Col>
                    <Col md="6">
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <label>{t('Name')}</label>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText name="name">
                            <i className="nc-icon nc-single-02" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input placeholder={t('Name')} type="text" />
                      </InputGroup>
                    </Col>
                    <Col md="6">
                      <label>{t('Email')}</label>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText name="email">
                            <i className="nc-icon nc-email-85" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input placeholder={t('Email')} type="text" />
                      </InputGroup>
                    </Col>
                  </Row>
                  <label>{t('Message')}</label>
                  <Input
                    name="message"
                    placeholder={t('WriteMessage')}
                    type="textarea"
                    rows="4"
                  />
                  <Row>
                    <Col className="ml-auto mr-auto" md="4">
                      <Button className="btn-fill" color="danger" size="lg">
                      {t('Send')}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Container>
        </div>
    </>
  )};

export default ContactUs;
